module.exports = __webpack_public_path__ + "media/images/flags/16/Grenada-ceab12dabde65c52f68336a8b11ac74f.png";